// extracted by mini-css-extract-plugin
export var cardWrapper = "_51-0";